import moment from "moment";

export const formatWorkOrderHistoryDateTime = (date?: string | null): string | null => {
    if (!date) {
        return null;
    }
    const parsed = moment(date);
    return parsed.isValid() ? parsed.format('DD. MMM YYYY HH:mm') : null;
};